<mat-form-field
  appearance="outline"
  [ngClass]="{ failed: !!UOMValidation || !validSnapshot || !!warning }"
  class="miq-form-input"
>
  <ng-container *ngIf="!isMaskedValue; else maskedInput">
    <input
      matInput
      [autocomplete]="autocompleteValue"
      [required]="required"
      [placeholder]="placeholder"
      [formControl]="fc"
      (keydown.enter)="onChange(customValue)"
      (blur)="blurChange()"
      [maxlength]="maxlength"
      [avoidCopyPaste]
      [avoidActions]="avoidCopyandPasteActions"
    />
    <mat-icon class="clear-button" *ngIf="clearButtonEnabled" (click)="clearValue()">close</mat-icon>
  </ng-container>

  <!-- DISPLAYED IF MASKED DATA -->
  <ng-template #maskedInput>
    <input
      matInput
      autocomplete="new-password"
      type="password"
      [placeholder]="placeholder"
      disabled
      [value]="currentValue"
      [avoidCopyPaste]
      [avoidAllActions]="true"
    />
  </ng-template>
</mat-form-field>
